export const VEHICLE_MARKER_KIND = 'vehicle';

export const SYMBOL_MARKER_OFFSET_EXPRESSION = [
    'case',
    ['==', ['get', 'markerKind'], VEHICLE_MARKER_KIND], ['literal', [0, 0]],
    ['literal', [0, -22]],
] as any;
